import type { Theme } from "../theme/pixel";
import { E32 } from "../theme/endesga32";

// 1-based pick order badge for multi-pick target prompts. Render
// inside a `position: relative` parent.
export function PickOrderBadge({ order, theme }: { order: number; theme: Theme }) {
  return (
    <div
      style={{
        position: "absolute",
        bottom: 4,
        right: -6,
        minWidth: 18,
        height: 18,
        padding: "0 5px",
        background: E32.amber,
        color: E32.ink,
        fontFamily: theme.fontDisplay,
        fontSize: 11,
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: `2px solid ${theme.bgDeep}`,
        pointerEvents: "none",
      }}
    >
      {order}
    </div>
  );
}
